import {PulseButton, withPulseAnimation} from './PulseButton.styled';

export default PulseButton;
export {withPulseAnimation};
